import type { ProjectCategory } from './projects'

export type ProjectCollection = {
  id: string
  title: string
  eyebrow: string
  description: string
  category: ProjectCategory
  accent: 'orange' | 'blue' | 'teal' | 'plum'
  searchTerms: string[]
}

export type OwnedSite = {
  id: string
  name: string
  url: string
  kind: 'Game' | 'Resource' | 'Studio'
  description: string
  action: string
  accent: 'orange' | 'blue' | 'teal' | 'plum'
}

export const projectCollections: ProjectCollection[] = [
  {
    id: 'azerothcore-playerbots',
    title: 'AzerothCore homebrew',
    eyebrow: 'Project collection / World of Warcraft',
    description:
      'Server modules and companion addons for operating and extending World of Warcraft 3.3.5a on AzerothCore, including mod-playerbots support.',
    category: 'Tools',
    accent: 'teal',
    searchTerms: ['azerothcore', 'homebrew', 'playerbots', 'wotlk', 'wow', 'world of warcraft', 'server module'],
  },
  {
    id: 'tenstorrent-blackhole',
    title: 'Blackhole experiments',
    eyebrow: 'Project collection / Tenstorrent',
    description:
      'A connected set of experiments in model execution, fused operations, and voice conversion on Tenstorrent hardware.',
    category: 'Hardware',
    accent: 'orange',
    searchTerms: ['tenstorrent', 'blackhole', 'ttnn', 'qwen', 'speech'],
  },
]

export const ownedSites: OwnedSite[] = [
  {
    id: 'oom',
    name: 'OOM!',
    url: 'https://oom.quest/',
    kind: 'Game',
    description: 'A work-in-progress browser healer simulator about managing mana, guiding an unruly party, and surviving branching dungeon runs.',
    action: 'Play OOM!',
    accent: 'plum',
  },
  {
    id: 'playshikaku',
    name: 'PlayShikaku',
    url: 'https://playshikaku.com',
    kind: 'Game',
    description: 'A fast browser-based Shikaku logic puzzle with generated boards, difficulty tiers, hints, and no account requirement.',
    action: 'Play Shikaku',
    accent: 'blue',
  },
  {
    id: 'bc250',
    name: 'BC250.info',
    url: 'https://bc250.info',
    kind: 'Resource',
    description: 'A practical setup, hardware, and benchmark resource for turning the AMD BC-250 into a capable Linux gaming PC.',
    action: 'Explore the guide',
    accent: 'orange',
  },
  {
    id: 'techmakesart',
    name: 'TechMakesArt',
    url: 'https://techmakesart.com',
    kind: 'Studio',
    description: 'The public-facing home for Kato’s apps, games, project stories, and broader creative work.',
    action: 'Visit TechMakesArt',
    accent: 'teal',
  },
]
